module.exports = __webpack_public_path__ + "static/media/chair.5626a074.png";